import { render, staticRenderFns } from "./manageList.vue?vue&type=template&id=5406d655&scoped=true&"
import script from "./manageList.vue?vue&type=script&lang=js&"
export * from "./manageList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5406d655",
  null
  
)

export default component.exports